export const getOrigin = () => {
  const ORIGINS = {
    // development: `http://${window.location.hostname}:3001/`,
    development: `http://${window.location.hostname}:5000/`,
    production: "https://vr.blazeit.sk/blaze-menu-builder/live-preview/",
    test: "",
  };

  const origin = ORIGINS[process.env.NODE_ENV];

  return origin;
};
